// import logo from './logo.svg';
import CryptoPup from './CryptoPup';
import './App.css';

function App() {
  return (
    <div className="App">
      <CryptoPup />
    </div>
  );
}

export default App;
